<template>
  <v-row class="fill-height">
    <v-col>
      <b-container fluid class="card p-4">
        <b-row>
          <b-col cols="6" class="col-header-calendar">
            <b-row>
              <v-btn class="mr-2" fab text small color="grey darken-2" @click="prev" :disabled="isLoading">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <h4 v-if="$refs.calendar" style="display: inline; font-size: 18px; margin-top: 10px">
                {{ calendarTitle }}
              </h4>


              <v-btn class="mr-2" fab text small color="grey darken-2" @click="next" :disabled="isLoading">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>

              <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y
                min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" style="height: 40px; width: 40px">
                    <v-icon size="30">mdi-calendar</v-icon>
                  </v-btn>
                </template>

                <v-date-picker v-model="filterDate" :header-date-format="formatDateHeader" :first-day-of-week="0"
                  no-title locale="vi-VN" class="calendar-list-page__body__date-picker" @change="onChangeDatePicker" />
              </v-menu>
              <b-button class="mr-2 calendar-list-page__body__today-button" @click="setToday">
                Hôm nay
              </b-button>

              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <b-button class="mr-2" size="sm" v-bind="attrs" v-on="on">

                    <v-icon :icon="getViewIcon(viewType)" font-scale="1" class="mr-1" />

                    {{ getViewLabel(viewType) }}

                    <b-icon icon="chevron-down" font-scale="1" class="ml-1" />
                  </b-button>

                </template>
                <v-list>
                  <v-list-item @click="changeViewType('month')">
                    <v-list-item-icon>
                      <v-icon small>mdi-calendar-month</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Tháng</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="changeViewType('week')">
                    <v-list-item-icon>
                      <v-icon small>mdi-calendar-week</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Tuần</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="changeViewType('day')">
                    <v-list-item-icon>
                      <v-icon small>mdi-calendar-today</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Ngày</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <b-button class="btn btn-success ml-2" size="sm" v-bind="attrs" v-on="on">
                    <v-icon small class="mr-1">mdi-filter</v-icon>
                    {{ getFilterLabel() }}
                    <v-icon small class="ml-1">mdi-chevron-down</v-icon>
                  </b-button>
                </template>
                <v-list>
                  <v-list-item @click="setFilter('all')">
                    <v-list-item-icon>
                      <v-icon small color="primary">mdi-calendar</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Xem tất cả</v-list-item-title>
                      <v-list-item-subtitle class="text-caption">Lịch trống + đã đặt</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action v-if="statusFilter === 'all'">
                      <v-icon color="success">mdi-check</v-icon>
                    </v-list-item-action>
                  </v-list-item>

                  <v-list-item @click="setFilter('available')">
                    <v-list-item-icon>
                      <v-icon small color="success">mdi-calendar-check</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Chỉ lịch trống</v-list-item-title>
                      <v-list-item-subtitle class="text-caption">Có thể đặt lịch</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action v-if="statusFilter === 'available'">
                      <v-icon color="success">mdi-check</v-icon>
                    </v-list-item-action>
                  </v-list-item>

                  <v-list-item @click="setFilter('booked')">
                    <v-list-item-icon>
                      <v-icon small color="error">mdi-calendar-clock</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Chỉ lịch đã đặt</v-list-item-title>
                      <v-list-item-subtitle class="text-caption">Đã có khách hàng</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action v-if="statusFilter === 'booked'">
                      <v-icon color="success">mdi-check</v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-menu>


            </b-row>
          </b-col>

          <b-col cols="6" class="d-flex justify-content-end">
            <b-row> </b-row>

            <b-button class="btn btn-secondary ml-2" type="button" @click.stop="loadData">
              <span class="svg-icon">
                <inline-svg src="/media/svg/icons/Neolex/Basic/refresh-cw.svg" />
              </span>
              {{ viewBool ? 'Đặt lại' : 'Làm mới' }}
            </b-button>

            <b-button class="btn btn-secondary ml-2" type="button" @click.stop="chooseCourse"
              v-show="isAssignPermission">
              <span class="svg-icon">
                <inline-svg src="/media/svg/icons/Neolex/Basic/search.svg" />
              </span>
              Chọn coach
            </b-button>

            <b-button :disabled="isLoading" class="btn btn-success ml-2" type="button" @click="handleEditAndSave"
              :variant="viewBool ? 'outline-success' : 'success'" v-if="viewType === 'week' && coachId !== 'All' && isInsertPermission">
              <span class="svg-icon">
                <inline-svg src="/media/svg/icons/Neolex/Basic/save.svg" />
              </span>
              {{ viewBool ? 'Lưu thay đổi' : 'Đặt lịch Coaching' }}
            </b-button>
            <b-modal id="confirmChangeModal" hide-footer hide-header-close no-close-on-backdrop no-close-on-esc
              title="Xác nhận thay đổi">
              <p>Bạn có chắc chắn muốn lưu lại các thay đổi?</p>
              <div class="d-flex justify-content-end">
                <b-button class="btn btn-secondary mr-2" @click="$bvModal.hide('confirmChangeModal')">Quay
                  lại</b-button>
                <b-button class="btn btn-success ml-3" @click="handleSubmit" :disabled="isConfirm">Xác nhận</b-button>
              </div>
            </b-modal>

            <b-modal id="deleteConfirmModal" hide-footer hide-header-close no-close-on-backdrop no-close-on-esc
              :title="deleteEventData.isRecurring ? 'Xóa lịch định kỳ' : 'Xác nhận xóa'">
              <div class="text-center mb-3">
                <p>Bạn muốn xóa lịch hẹn:</p>
                <p><strong>{{ deleteEventData.displayName }}</strong></p>
                <p v-if="deleteEventData.isRecurring">
                  <span class="recurring-label">{{ deleteEventData.recurringLabel }}</span>
                </p>
                <p><strong>Thời gian: {{ deleteEventData.timeRange }}</strong></p>
              </div>
              <div class="d-flex justify-content-center">
                <b-button variant="secondary" class="mr-2" @click="$bvModal.hide('deleteConfirmModal')">
                  Huỷ bỏ
                </b-button>
                <b-button variant="success" class="mr-2" @click="confirmDeleteSingle" v-if="deleteEventData.isRecurring && isDeletePermission">
                  Xóa buổi này
                </b-button>
                <b-button variant="success" @click="confirmDeleteAll" v-if="isDeletePermission">
                  {{ deleteEventData.isRecurring ? 'Xóa chuỗi sự kiện' : 'Xác nhận xóa' }}
                </b-button>
              </div>
            </b-modal>

            <b-modal id="bookingModal" hide-footer hide-header-close no-close-on-backdrop no-close-on-esc size="xl"
              title="Xác nhận đặt lịch">
              <b-overlay :show="loading" rounded="sm">
              <div class="row">
                <!-- LEFT: booking form -->
                <div class="col-md-4 border-right pr-3">
                  <basic-select v-model="selectedAccount" :options="customerValid" track-by="accountId"
                    value-label="displayDetail" label="Khách hàng" :required="true" changeValueByObject
                    @input="onAccountSelected" :disabled="isDisableSelectPhone" />

                  <basic-select v-model="selectedTime" :options="availableTime" track-by="startTime"
                    value-label="startTimeDisplay" label="Thời gian" :required="true" changeValueByObject />

                  <basic-select v-model="selectedType" :options="filteredCalendarType" track-by="value"
                    value-label="text" label="Loại đặt hẹn" :required="true" changeValueByObject
                    :disabled="isDisableSelectPhone" />

                  <!-- Recurrence Section - Chỉ hiển thị khi loại là Cá nhân (32) -->
                  <div v-if="selectedType?.value === '32'" class="recurrence-section mt-3 mb-3">
                    <b-form-checkbox v-model="isRecurrence" class="mb-2">
                      <span class="font-weight-bold">Cuộc họp định kỳ</span>
                    </b-form-checkbox>

                    <div v-if="isRecurrence" class="recurrence-options p-3 border rounded bg-light">
                      <b-row>
                        <b-col cols="6">
                          <basic-select
                            v-model="recurrence.type"
                            :options="recurrenceTypeOptions"
                            track-by="value"
                            value-label="text"
                            label="Tái diễn"
                            changeValueByObject
                          />
                        </b-col>
                        <b-col cols="6">
                          <basic-select
                            v-model="recurrence.interval"
                            :options="recurrenceIntervalOptions"
                            track-by="value"
                            value-label="text"
                            :label="'Lặp lại mỗi (' + recurrenceUnitText + ')'"
                            changeValueByObject
                          />
                        </b-col>
                      </b-row>

                      <b-row class="mt-2">
                        <b-col cols="6">
                          <basic-select
                            v-model="recurrence.occurrences"
                            :options="recurrenceOccurrencesOptions"
                            track-by="value"
                            value-label="text"
                            label="Kết thúc sau (buổi)"
                            changeValueByObject
                          />
                        </b-col>
                      </b-row>
                    </div>
                  </div>

                  <div class="d-flex justify-content-end ml-3">
                    <b-button class="btn btn-secondary mr-2" @click="closeModalBooking">
                      Đóng
                    </b-button>
                    <b-button class="btn btn-success ml-3" @click="createBooking" :disabled="isConfirm">
                      {{ bookingButtonText }}
                    </b-button>
                  </div>
                </div>

                <!-- RIGHT: booking history -->
                <div class="col-md-8 pl-3">
                  <h5>Lịch sử đặt hẹn</h5>
                  <div class="history-table-sm">
                    <template-table
                      :column="historyColumns"
                      :data="pagedBookedHistory"
                      :paging="historyPaging"
                      :tableAction="false"
                      :searchAction="false"
                      :selectAction="false"
                      :btnPrimary="false"
                      :btnInactiveSelected="false"
                    >
                      <template v-slot:body="{ item }">
                        <td class="text-left">
                          <strong>{{ item.name }}</strong>
                        </td>
                        <td class="text-center">
                          {{ formatTimeCompact(item.appointmentDate) }}
                        </td>
                        <td class="text-center">
                          <span v-if="item.type === 30">Đầu vào</span>
                          <span v-else-if="item.type === 31">Đầu ra</span>
                          <span v-else-if="item.type === 32">Cá nhân</span>
                          <span v-else>-</span>
                        </td>
                        <td class="text-center">
                          <span :class="item.isDeleted ? 'text-danger' : 'text-success'">
                            {{ item.isDeleted ? 'Đã hủy' : (item.appointmentDate * 1000 > Date.now() ? 'Sắp tới' : 'Hoàn thành') }}
                          </span>
                        </td>
                      </template>
                    </template-table>
                  </div>
                </div>

              </div>
              </b-overlay>
            </b-modal>


          </b-col>
        </b-row>
        <b-row>
          <b-col cols="5">
            <b-row>
              <b-col cols="4">
                <h6 class="mb-2" v-if="
                  this.filteredEvents.filter((event) => event.status === 0).length > 0
                ">
                  Tổng chỗ đặt: <strong>{{ this.filteredEvents.length }}</strong>
                </h6>
                <h6 class="mb-2">
                  Số chỗ đã được đặt:
                  <strong>{{
                    this.filteredEvents.filter((event) => event.status === 1).length
                  }}</strong>
                </h6>
              </b-col>
              <b-col cols="8">
                <h6 class="mb-2">
                  Health coach quản lý:
                  <strong>
                    {{
                      [
                        ...new Set(
                          this.filteredEvents
                            .filter((event) => event.name)
                            .map((event) => event.name),
                        ),
                      ].length === 1
                        ? this.filteredEvents.filter((event) => event.name)[0].name
                        : 'Admin'
                    }}
                  </strong>
                </h6>

                <h6 class="mb-2" v-if="
                  this.filteredEvents.filter((event) => event.status === 0).length > 0
                ">
                  Cuộc hẹn tiếp theo:
                  <strong>
                    {{
                      this.filteredEvents
                        .filter((event) => event.status === 1)
                        .sort(
                          (a, b) => new Date(a.start) - new Date(b.start),
                        )[0]?.start | moment('DD/MM/YYYY HH:mm')
                    }}
                  </strong>
                </h6>
              </b-col>

              <v-card v-for="(eventGroup, index) in getUniqueCoaches()" :key="`coach-${index}-${eventGroup}`"
                class="mb-1" v-show="getFilteredBookedEventsForCoach(eventGroup).length > 0">
                <v-card-text>
                  <h4 style="text-align: center;">
                    <strong>{{ eventGroup }}</strong>
                  </h4>
                  <ul>
                    <li v-for="(event, idx) in getFilteredBookedEventsForCoach(eventGroup)"
                      :key="`event-${event.start}-${idx}`" :style="{
                        backgroundColor: event.color,
                        color: getContrastYIQ(event.color),
                      }" class="event-item event-item-clickable" @click="showEventDetails(event)"
                      :title="`Click để xem chi tiết cuộc hẹn ${formatDateOnly(event.start)}`">
                      <div class="event-row">
                        <span class="event-time">
                          {{ formatEventTimeSummary(event.start, event.end) }}
                        </span>

                        <span v-if="event.statusMeeting === true || event.statusMeeting === 'started' || event.statusMeeting === 1" class="event-badge" title="Cuộc hẹn đã bắt đầu">
                          <small>Đang diễn ra</small>
                        </span>
                      </div>
                    </li>
                  </ul>

                </v-card-text>
              </v-card>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
      <v-sheet height="650">
        <v-calendar ref="calendar" v-model="value" :event-color="getEventColor" :event-ripple="false"
          :events="filteredEvents" color="#c1d1ee" :type="viewType" :event-more="false" :event-height="20"
          :short-intervals="false" :show-month-on-first="viewType === 'month'" @change="onCalendarChange"
          @mousedown:event="startDrag" @mousedown:time="startTime" @mouseleave="cancelDrag" @mousemove:time="mouseMove"
          @mouseup:time="endDrag" @click:event="showEvent" locale="vi-VN">
          <template v-slot:event="{ event }" v-if="viewType === 'month'">

            <div class="v-event-month" :style="{ backgroundColor: event.color, color: getContrastYIQ(event.color) }">
              <div class="event-time-month">
                {{ formatEventTimeShort(event.start) }}
              </div>
              <span v-if="isRecurringEvent(event.name || event.calendarName)" class="recurring-badge-month">
                {{ getRecurringLabel(event.name || event.calendarName) }}
              </span>
              <div class="event-title-month">
                {{ getEventDisplayName(event.name || event.calendarName) }}
              </div>
            </div>
          </template>

          <template v-slot:event="{ event, timed }" v-else>
            <div class="v-event-draggable" :class="{ 'dense-event': isDenseDay(event.start) }">
              <div class="event-content" :style="{ backgroundColor: event.color, color: getContrastYIQ(event.color) }">
                <div class="event-time">
                  {{ formatEventTime(event.start, event.end) }}
                </div>
                <span v-if="isRecurringEvent(event.calendarName)" class="recurring-badge">
                  {{ getRecurringLabel(event.calendarName) }}
                </span>
                <div class="event-name">
                  {{ getEventDisplayName(event.calendarName) }}
                </div>

              </div>
            </div>
            <div v-if="timed" class="v-event-drag-bottom" @mousedown.stop="extendBottom(event)"></div>
          </template>

          <template v-slot:day-body="{ date, week }" v-if="viewType !== 'month'">
            <div class="v-current-time" :class="{ first: date === week[0].date }" :style="{ top: nowY }"></div>
          </template>

          <template v-slot:day="{ date }" v-if="viewType === 'month'">
            <div class="v-calendar-month-day">
              {{ date.day }}
            </div>
          </template>
        </v-calendar>

        <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" :absolute="false"
          value="true" bottom left>
          <v-card color="grey lighten-4" min-width="350px" flat>
            <v-toolbar :color="selectedEvent.color" dark>
              <v-toolbar-title>
                {{ formattedEventTime }}
                <div class="text-subtitle-2">{{ selectedEvent.calendarName }}</div>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="removeEvent" v-show="selectedEvent.status == null || selectedEvent.status == 0
                ">
                <v-icon>mdi-trash-can</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text v-if="selectedEvent.status == 1">
              <div class="event-details">
                <div class="detail-item">
                  <strong>Status:</strong>
                  {{ selectedEvent.status === 0 ? 'Available' : 'Booked' }}<br>
                  <strong>Meeting Name:</strong>
                  {{ selectedEvent.calendarName }}<br>
                  <strong v-show="selectedEvent.phone != null">Phone:</strong>
                  {{ selectedEvent.phone }}<br>
                  <strong>Meeting Id:</strong>
                  {{ selectedEvent.roomId }}<br>
                  <strong>Pass Code:</strong>
                  {{ selectedEvent.passCode }}<br>
                  <strong>Zoom Host:</strong>
                  {{ selectedEvent.hostEmail }}<br>
                  <strong>Health coach:</strong>
                  {{ selectedEvent.name }}
                </div>
              </div>
            </v-card-text>

            <v-card-actions>
              <b-button @click="selectedOpen = false">
                Đóng
              </b-button>
              <span class="flex-grow-1"></span>
              <b-button @click="handleBooking(selectedEvent)" v-if="coachId != 'All' && isInsertPermission" class="btn btn-success ml-3">
                {{ selectedEvent.status === 1 ? 'Đổi lịch' : 'Đặt lịch' }}
              </b-button>
              <b-button @click="showPopupConfirm(selectedEvent)" v-if="coachId != 'All' && selectedEvent.status == 1"
                class="btn btn-inactive ml-3">
                Xóa hẹn
              </b-button>
              <b-button class="btn btn-success ml-3" @click="openMeetingLink(selectedEvent.meetingLink)"
                v-show="selectedEvent.status == 1">
                Mở cuộc họp (host)
              </b-button>
              <b-button class="btn btn-success ml-3" @click="copyLink(selectedEvent.calendarLinkDynamic)"
                v-show="selectedEvent.status == 1">
                Copy link (khách hàng)
              </b-button>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>
    </v-col>
    <select-course-modal @selected-success="
      loadData();
    showCalendar = true;
    " :currentUser="this.currentUser" />
  </v-row>
</template>

<script>
import { createNamespacedHelpers, mapGetters } from 'vuex';
import moment from 'moment-timezone';
import { convertToTimestamp, convertTimestampToDateTime } from '../../../core/utils/dateUtils';
import { ONBOARDING } from '../customer_receives/CustomerReceiveEnum.js';
const { mapState } = createNamespacedHelpers('calendarCoach');

export default {
  name: 'CoachesCalendar',
  components: {
    'select-course-modal': () => import('./components/SelectCourseModal.vue'),
    'template-table': () => import('@/components/table/template-table.vue'),
  },
  data: () => ({
    value: '',
    events: [],
    statusFilter: 'all',
    names: [
      'Meeting',
      'Holiday',
      'PTO',
      'Travel',
      'Event',
      'Birthday',
      'Conference',
      'Party',
    ],
    courseSelected: null,
    coachSelected: null,
    dragEvent: null,
    dragStart: null,
    createEvent: null,
    createStart: null,
    extendOriginal: null,
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    ready: false,
    oldEvents: {},
    viewBool: false,
    count: 1,
    isLoading: false,
    loading: false,
    valueprocess: 10,
    bufferValue: 20,
    isConfirm: false,
    filterDate: new Date().toISOString().substr(0, 10),
    menu: false,
    viewType: 'week',
    customerValid: [],
    selectedAccount: null,
    calendarType: [
      {
        value: '30',
        text: 'Phỏng vấn đầu vào'
      },
      {
        value: '31',
        text: 'Phỏng vấn đầu ra'
      },
      {
        value: '32',
        text: 'Phỏng vấn cá nhân'
      }
    ],
    // History table columns for template-table
    historyColumns: [
      { key: 'name', label: 'Tên buổi họp', sortable: false, class: 'text-left', style: 'font-size: 12px' },
      { key: 'appointmentDate', label: 'Thời gian', sortable: false, class: 'text-center', style: 'font-size: 12px' },
      { key: 'type', label: 'Loại đặt hẹn', sortable: false, class: 'text-center', style: 'font-size: 12px; min-width: 100px' },
      { key: 'isDeleted', label: 'Trạng thái', sortable: false, class: 'text-center', style: 'font-size: 12px' }
    ],
    // History table paging
    historyPaging: {
      page: 1,
      pageSize: 5,
      total: 0,
    },

    availableTime: [],
    bookedHistory: [],
    bookingButtonText: 'Đặt lịch',
    selectedType: '',
    selectedTime: null,
    isChangeBooked: false,
    isDisableSelectPhone: false,
    meetingIds: [],
    status: 'waiting',
    // Recurrence data
    isRecurrence: false,
    recurrence: {
      type: { value: 'daily', text: 'Hàng ngày' },
      interval: { value: 1, text: '1' },
      endType: 'occurrences',
      endDate: '',
      occurrences: { value: 7, text: '7' },
    },
    recurrenceTypeOptions: [
      { value: 'daily', text: 'Hàng ngày' },
      { value: 'weekly', text: 'Hàng tuần' },
      { value: 'monthly', text: 'Hàng tháng' },
    ],
    recurrenceIntervalOptions: Array.from({ length: 30 }, (_, i) => ({ value: i + 1, text: String(i + 1) })),
    recurrenceOccurrencesOptions: Array.from({ length: 30 }, (_, i) => ({ value: i + 1, text: String(i + 1) })),
    // Delete modal data
    deleteEventData: {
      event: null,
      isRecurring: false,
      displayName: '',
      recurringLabel: '',
      timeRange: '',
    },
  }),
  methods: {

    async createBooking() {
      try {
        this.isConfirm = true;
        this.loading = true;

        const startTime = this.selectedTime.startTime;
        const endTime = this.selectedTime.startTime;
        const calendarCoachId = this.selectedTime.id;

        const payload = {
          zoomTypeId: 1,
          appointmentDate: startTime,
          type: this.selectedType?.value || this.selectedType,
          performerId: this.coachId,
          name: this.selectedType?.text + " - " + this.selectedAccount.name,
          goal: this.selectedType?.text,
          duration: 3600,
          userId: this.selectedTime.zoomUserId,
          calendarAccounts: [
            {
              accountId: this.selectedAccount.accountId,
              calendarId: "00000000-0000-0000-0000-000000000000",
              modelStatus: 3
            }
          ],
          calendarCoachs: [
            {
              id: calendarCoachId,
              coachId: this.coachId,
              courseId: ONBOARDING.ID,
              startTime,
              endTime,
              status: 0
            }
          ],
          courseId: ONBOARDING.ID
        };

        // Thêm recurrence data nếu là đặt hẹn cá nhân và có chọn định kỳ
        if (this.isRecurrence && this.selectedType?.value === '32') {
          const recurrenceTypeMap = {
            daily: 0,
            weekly: 1,
            monthly: 2,
          };

          // Extract values from objects
          const typeValue = this.recurrence.type?.value || this.recurrence.type;
          const intervalValue = this.recurrence.interval?.value || this.recurrence.interval;
          const occurrencesValue = this.recurrence.occurrences?.value || this.recurrence.occurrences;

          payload.repeatType = 4; // ManualConfig
          payload.calendarScheduler = {
            repeatTime: intervalValue,
            repeatType: recurrenceTypeMap[typeValue],
            isRepeatInfinite: false,
            modelStatus: 3,
          };

          // Tính endDate dựa trên số buổi
          const startMoment = this.$moment.unix(startTime);
          let endMoment;
          if (typeValue === 'daily') {
            endMoment = startMoment.clone().add(intervalValue * (occurrencesValue - 1), 'days');
          } else if (typeValue === 'weekly') {
            endMoment = startMoment.clone().add(intervalValue * (occurrencesValue - 1), 'weeks');
          } else if (typeValue === 'monthly') {
            endMoment = startMoment.clone().add(intervalValue * (occurrencesValue - 1), 'months');
          }
          payload.calendarScheduler.endDate = endMoment.unix();
        }

        if (this.isChangeBooked) {
          const formData = new FormData();
          formData.append("CalendarCoachId", this.selectedEvent.id);
          formData.append("DeleteType", 0);

          const response = await this.$api.post(`Calendar/portal/delete/booking/${this.selectedEvent.calendarId}`, formData);

          if (response.meta.success) {
            try {
              await this.$api.post("Calendar/portal/booking", payload);
              this.$toastr.s({
                title: "Thành công",
                msg: "Đổi lịch thành công",
              });
            } catch (error) {
              const errorMsg = error?.response?.data?.message
                || error?.response?.data?.meta?.message
                || error?.message
                || "Đổi lịch thất bại";
              this.$toastr.e({
                title: "Lỗi",
                msg: errorMsg,
              });
            }
          } else {
            const errorMsg = response?.meta?.message || "Đổi lịch thất bại";
            this.$toastr.e({
              title: "Lỗi",
              msg: errorMsg,
            });
          }

        } else {
          try {
            await this.$api.post("Calendar/portal/booking", payload);
            this.$toastr.s({
              title: "Thành công",
              msg: "Đặt lịch thành công",
            });

          } catch (error) {
            const errorMsg = error?.response?.data?.message
              || error?.response?.data?.meta?.message
              || error?.message
              || "Đặt lịch thất bại";
            this.$toastr.e({
              title: "Lỗi",
              msg: errorMsg
            });
          }
        }
      } catch (error) {
        const errorMsg = error?.response?.data?.message
          || error?.response?.data?.meta?.message
          || error?.message
          || "Đặt lịch thất bại";
        this.$toastr.e({
          title: "Lỗi",
          msg: errorMsg
        });
      } finally {
        this.loading = false;
        await this.loadData();
        this.closeModalBooking();
        this.isConfirm = false;
        this.isDisableSelectPhone = false;
      }
    },


    async loadDataCustomer() {
      try {
        // Đặt lịch luôn cho 1 coach cụ thể; chưa chọn coach thì không có khách để chọn
        if (!this.coachId || this.coachId === 'All') {
          this.customerValid = [];
          return;
        }
        // Lọc theo coach ở BE (bản cũ lấy 1000 khách đầu của mọi coach rồi lọc ở FE nên sót khách khi vượt 1000).
        // /All không phân trang và không enrich từng dòng như list, trả về mảng thô
        const data = await this.$api.get('CustomerReceives/All', {
          params: {
            status: 1,
            coachId: this.coachId,
            isDeleted: false,
          }
        });
        const filteredData = (Array.isArray(data) ? data : []).filter((el) => el.status == 1 && el.coachId == this.coachId);
        this.customerValid =
          filteredData?.map((el) => {
            return {
              ...el,
              displayDetail: el.name + " (" + el.phoneNumber + ")"
            };
          }) || [];

      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },

    async loadValidSlotByCoach(type = 'week') {
      try {
        const fromDate = new Date();
        const toDate = new Date(fromDate);

        if (type === 'day') {
          toDate.setDate(fromDate.getDate() + 1);
        } else if (type === 'week') {
          toDate.setDate(fromDate.getDate() + 7);
        } else if (type === 'month') {
          toDate.setMonth(fromDate.getMonth() + 1);
        }

        const { data } = await this.$api.get('CalendarCoach', {
          params: {
            StartTime: convertToTimestamp(fromDate),
            CoachId: this.coachId,
            AccountId: this.selectedAccount.accountId,
            CourseId: ONBOARDING.ID
          },
        });
        this.availableTime = (data || [])
          .filter(el =>
            el.status === 0 &&
            el.isDeleted === false &&
            el.startTime * 1000 > Date.now()
          )
          .map(el => {
            const start = moment(el.startTime * 1000).subtract(7, 'hours');
            const end = moment(el.endTime * 1000).subtract(7, 'hours');
            return {
              ...el,
              startTimeDisplay: `${start.format('DD/MM HH:mm')} - ${end.format('DD/MM HH:mm')}`
            };
          });



      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },

    async loadBookedMeeting() {
      try {
        const { data } = await this.$api.get('Calendar/BookedByAccountId', {
          params: {
            CoachId: this.coachId,
            AccountId: this.selectedAccount.accountId,
            CourseId: ONBOARDING.ID
          },
        });
        // Sort by appointmentDate descending (newest first)
        this.bookedHistory = (data || [])
          .map(el => ({ ...el }))
          .sort((a, b) => b.appointmentDate - a.appointmentDate);

        // Update paging total
        this.historyPaging.total = this.bookedHistory.length;
        this.historyPaging.page = 1;
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },

    getUniqueCoaches() {
      const uniqueCoaches = [...new Set(this.events
        .filter(e => e.name && e.name.trim() !== '' && e.color !== '#01645A')
        .map(e => e.name)
      )];
      return uniqueCoaches;
    },

    getFilteredBookedEventsForCoach(coachName) {
      const bookedEvents = this.events
        .filter(e => e.name === coachName && e.status === 1);

      return this.filterEventsByCurrentView(bookedEvents);
    },

    filterEventsByCurrentView(events) {
      const currentDate = moment(this.value || this.filterDate || new Date());

      return events.filter(event => {
        const eventDate = moment(event.start);

        switch (this.viewType) {
          case 'month':
            return eventDate.isSame(currentDate, 'month');

          case 'week':
            return eventDate.isSame(currentDate, 'week');

          case 'day':
            return eventDate.isSame(currentDate, 'day');

          default:
            return eventDate.isSame(currentDate, 'month');
        }
      }).sort((a, b) => new Date(a.start) - new Date(b.start));
    },

    showEventDetails(event) {
      const fullEvent = this.events.find(e =>
        e.start === event.start &&
        e.end === event.end &&
        e.name === event.name
      );

      if (fullEvent) {
        this.selectedEvent = fullEvent;

        const fakeElement = document.createElement('div');
        fakeElement.style.position = 'absolute';
        fakeElement.style.left = '50%';
        fakeElement.style.top = '50%';
        fakeElement.style.width = '1px';
        fakeElement.style.height = '1px';
        document.body.appendChild(fakeElement);

        this.selectedElement = fakeElement;

        // Hiển thị menu chi tiết
        this.$nextTick(() => {
          this.selectedOpen = true;
          setTimeout(() => {
            if (fakeElement && fakeElement.parentNode) {
              fakeElement.parentNode.removeChild(fakeElement);
            }
          }, 100);
        });

        this.navigateToEventDate(event);
      } else {
        this.$toastr.e({
          title: 'Không tìm thấy',
          msg: 'Không thể tìm thấy thông tin chi tiết của cuộc hẹn này',
        });
      }
    },

    getBookedEventsForCoach(coachName) {
      return this.events
        .filter(e => e.name === coachName && e.status === 1)
        .sort((a, b) => new Date(a.start) - new Date(b.start));
    },

    navigateToEventDate(event) {
      if (!event || !event.start) {
        return;
      }

      const eventDate = new Date(event.start);
      const dateString = eventDate.toISOString().substr(0, 10);

      this.value = dateString;
      this.filterDate = dateString;
      this.viewType = 'day';

      this.$nextTick(() => {
        if (this.$refs.calendar) {
          this.$refs.calendar.checkChange();
        }

        setTimeout(() => {
          this.scrollToEventTime(event.start);
        }, 300);
      });
    },

    scrollToEventTime(eventStartTime) {
      if (!this.$refs.calendar) return;

      const eventTime = new Date(eventStartTime);
      const hours = eventTime.getHours();
      const minutes = eventTime.getMinutes();
      const timeInMinutes = hours * 60 + minutes;

      try {
        // Tính toán vị trí scroll dựa trên thời gian
        const scrollTime = Math.max(0, timeInMinutes - 60); // Scroll trước 1 tiếng
        this.$refs.calendar.scrollToTime(scrollTime);
      } catch (error) {
        // Ignore scroll errors
        console.debug('Scroll error:', error);
      }
    },

    formatDateOnly(date) {
      return moment(date).format('DD/MM/YYYY');
    },

    formatDateHeader(date) {
      return new Date(date).toLocaleDateString('vi-VN', {
        month: 'long',
        year: 'numeric',
      });
    },

    setFilter(filterType) {
      this.statusFilter = filterType;
      this.$toastr.s({
        title: 'Bộ lọc đã được áp dụng',
        msg: this.getFilterLabel(),
      });
    },

    getFilterLabel() {
      switch (this.statusFilter) {
        case 'available':
          return 'Chỉ lịch trống';
        case 'booked':
          return 'Chỉ lịch đã đặt';
        default:
          return 'Xem tất cả';
      }
    },

    getCurrentViewDescription() {
      const currentDate = moment(this.value || this.filterDate || new Date());

      switch (this.viewType) {
        case 'month':
          return `tháng ${currentDate.format('MM/YYYY')}`;
        case 'week': {
          const startOfWeek = currentDate.clone().startOf('week');
          const endOfWeek = currentDate.clone().endOf('week');
          return `tuần từ ${startOfWeek.format('DD/MM')} đến ${endOfWeek.format('DD/MM/YYYY')}`;
        }
        case 'day':
          return `ngày ${currentDate.format('DD/MM/YYYY')}`;
        default:
          return `tháng ${currentDate.format('MM/YYYY')}`;
      }
    },

    copyLink(link) {
      if (link) {
        navigator.clipboard.writeText(link);
        this.$toastr.s({
          title: 'Sao chép thành công',
          msg: 'Đường dẫn tham gia zoom qua ứng dụng DIAB',
        });
      }
    },

    openMeetingLink(link) {
      window.open(link, '_blank');
    },

    getContrastYIQ(color) {
      const hex = color.replace(/^#/, '');
      const r = parseInt(hex.substr(0, 2), 16);
      const g = parseInt(hex.substr(2, 2), 16);
      const b = parseInt(hex.substr(4, 2), 16);
      const yiq = (r * 299 + g * 587 + b * 114 + 500) / 1000;
      return yiq >= 128 ? 'black' : 'white';
    },

    isDenseDay(date) {
      const dayEvents = this.filteredEvents.filter((event) => {
        const eventDate = new Date(event.start).setHours(0, 0, 0, 0);
        const checkDate = new Date(date).setHours(0, 0, 0, 0);
        return eventDate === checkDate;
      });
      return dayEvents.length > 3;
    },

    async handleEditAndSave() {
      this.viewBool = !this.viewBool;
      if (!this.viewBool) {
        this.$root.$emit('bv::show::modal', 'confirmChangeModal');
      }
    },

    async onAccountSelected(viewType) {
      if (viewType) {
        await this.loadValidSlotByCoach(viewType)
        //  await this.loadBookedMeeting()
      }
    },

    async handleBooking(selectedEvent) {
      this.$store.commit('context/setLoading', true);
      if (selectedEvent.status == 1) {
        // Đổi lịch - click vào booking đã có
        try {
          this.selectedAccount = { displayDetail: selectedEvent.customerName + " (" + selectedEvent.phone + ")", accountId: selectedEvent.accountId, name: selectedEvent.customerName };
          this.selectedType = { value: selectedEvent.type, text: selectedEvent.goal };
          this.isDisableSelectPhone = true;
          this.isChangeBooked = true;
          this.bookingButtonText = 'Đổi lịch';
          this.$root.$emit('bv::show::modal', 'bookingModal');
          await this.loadDataCustomer();

          this.$toastr.s({
            title: 'Thành công !',
            msg: 'Cập nhật thành công',
          });
        }
        catch {
          this.$toastr.e({
            title: 'Đã xảy ra lỗi',
            msg: 'Không khả dụng đặt lịch',
          });
          this.$store.commit('context/setLoading', false);
        } finally {
          this.$store.commit('context/setLoading', false);
        }

      }
      else {
        // Đặt lịch mới - click vào slot trống
        this.isChangeBooked = false;
        this.bookingButtonText = 'Đặt lịch';
        this.$root.$emit('bv::show::modal', 'bookingModal');
        await this.loadDataCustomer();
        this.$store.commit('context/setLoading', false);

      }
    },

    showPopupConfirm(selectedEvent) {
      const startTime = moment(this.selectedEvent.start).format('HH:mm');
      const endTime = moment(this.selectedEvent.end).format('HH:mm');
      const isRecurring = this.isRecurringEvent(selectedEvent.calendarName);

      // Set delete event data for modal
      this.deleteEventData = {
        event: selectedEvent,
        isRecurring: isRecurring,
        displayName: this.getEventDisplayName(selectedEvent.calendarName),
        recurringLabel: isRecurring ? this.getRecurringLabel(selectedEvent.calendarName) : '',
        timeRange: `${startTime} - ${endTime}`,
      };

      // Show the delete confirmation modal
      this.$bvModal.show('deleteConfirmModal');
    },

    confirmDeleteSingle() {
      this.$bvModal.hide('deleteConfirmModal');
      if (this.deleteEventData.event) {
        this.handleDeleteBooking(this.deleteEventData.event, 0);
      }
    },

    confirmDeleteAll() {
      this.$bvModal.hide('deleteConfirmModal');
      if (this.deleteEventData.event) {
        const deleteType = this.deleteEventData.isRecurring ? 2 : 0;
        this.handleDeleteBooking(this.deleteEventData.event, deleteType);
      }
    },

    async handleDeleteBooking(selectedEvent, deleteType = 0) {
      console.log("=== handleDeleteBooking called ===");
      console.log("selectedEvent:", selectedEvent);
      console.log("deleteType:", deleteType);
      console.log("calendarId:", selectedEvent.calendarId);
      console.log("calendarCoachId:", selectedEvent.id);

      try {
        this.$store.commit('context/setLoading', true);

        const formData = new FormData();
        formData.append("CalendarCoachId", selectedEvent.id);
        formData.append("DeleteType", deleteType);

        console.log("Calling API: Calendar/portal/delete/booking/" + selectedEvent.calendarId);
        const response = await this.$api.post(`Calendar/portal/delete/booking/${selectedEvent.calendarId}`, formData);
        console.log("API response:", response);

        if (response.meta.success) {
          this.$toastr.s({
            title: "Thành công",
            msg: "Xóa lịch hẹn thành công",
          });

        }
        else
          this.$toastr.e({
            title: "Thất bại",
            msg: "Xóa lịch hẹn thất bại",
          });

      }
      catch {
        this.$toastr.e({
          title: "Thất bại",
          msg: "Xóa lịch hẹn thất bại",
        });

      } finally {
        this.$store.commit('context/setLoading', false);
        this.loadData();
      }
    },

    importForm() {
      this.$bvModal.show('form-modal');
    },

    startDrag({ event, timed }) {
      if (!this.viewBool && event?.status !== 1) return;
      if (event && timed) {
        this.dragEvent = event;
        this.dragTime = null;
        this.extendOriginal = null;
      }
    },

    startTime(tms) {
      if (!this.viewBool && this.dragEvent?.status !== 1) return;

      const mouse = this.toTime(tms);

      if (this.dragEvent && this.dragTime === null) {
        const start = this.dragEvent.start;
        this.dragTime = mouse - start;
      } else {
        this.createStart = this.roundTime(mouse);
        this.createEvent = {
          name: this.coachName,
          color: '#01645A',
          start: this.createStart,
          end: this.roundTime(this.createStart + 30 * 60 * 1000),
          timed: true,
        };
        this.events.push(this.createEvent);
      }
    },

    extendBottom(event) {
      this.createEvent = event;
      this.createStart = event.start;
      this.extendOriginal = event.end;
    },

    mouseMove(tms) {
      if (!this.viewBool && this.dragEvent?.status !== 1) return;

      const mouse = this.toTime(tms);

      if (this.dragEvent && this.dragTime !== null) {
        const start = this.dragEvent.start;
        const end = this.dragEvent.end;
        const duration = end - start;
        const newStartTime = mouse - this.dragTime;
        const newStart = this.roundTime(newStartTime);
        const newEnd = newStart + duration;
        const startDate = new Date(newStart).getDate();
        const endDate = new Date(newEnd).getDate();
        if (startDate === endDate) {
          this.dragEvent.start = newStart;
          this.dragEvent.end = newEnd;
        }
      } else if (this.createEvent && this.createStart !== null) {
        const mouseRounded = this.roundTime(mouse, false);
        const min = Math.min(mouseRounded, this.createStart);
        const max = Math.max(mouseRounded, this.createStart);
        const oldEndDate = new Date(this.createEvent.end).getDate();
        const maxDate = new Date(max).getDate();
        const minDate = new Date(min).getDate();

        if (oldEndDate === maxDate && minDate === maxDate) {
          this.createEvent.start = min;
          this.createEvent.end = max;
        }
      }
    },

    endDrag() {
      if (!this.viewBool && this.dragEvent?.status !== 1) return;

      this.dragTime = null;
      this.dragEvent = null;
      this.createEvent = null;
      this.createStart = null;
      this.extendOriginal = null;
    },

    cancelDrag() {
      if (!this.viewBool) {
        return;
      }
      if (this.createEvent) {
        if (this.extendOriginal) {
          this.createEvent.end = this.extendOriginal;
        } else {
          const i = this.events.indexOf(this.createEvent);
          if (i !== -1) {
            this.events.splice(i, 1);
          }
        }
      }
      this.createEvent = null;
      this.createStart = null;
      this.dragTime = null;
      this.dragEvent = null;
    },

    roundTime(time, down = true) {
      const roundTo = 30;
      const roundDownTime = roundTo * 60 * 1000;
      return down
        ? time - (time % roundDownTime)
        : time + (roundDownTime - (time % roundDownTime));
    },

    toTime(tms) {
      return new Date(
        tms.year,
        tms.month - 1,
        tms.day,
        tms.hour,
        tms.minute,
      ).getTime();
    },

    getEventColor(event) {
      const rgb = parseInt(event.color.substring(1), 16);
      const r = (rgb >> 16) & 0xff;
      const g = (rgb >> 8) & 0xff;
      const b = (rgb >> 0) & 0xff;

      return event === this.dragEvent
        ? `rgba(${r}, ${g}, ${b}, 0.7)`
        : event === this.createEvent
          ? `rgba(${r}, ${g}, ${b}, 0.7)`
          : event.color;
    },

    getEvents({ start, end }) {
      const events = [];
      const min = new Date(`${start.date}T00:00:00`).getTime();
      const max = new Date(`${end.date}T23:59:59`).getTime();
      const days = (max - min) / 86400000;
      const eventCount = this.rnd(days, days + 20);

      for (let i = 0; i < eventCount; i++) {
        const timed = this.rnd(0, 3) !== 0;
        const firstTimestamp = this.rnd(min, max);
        const secondTimestamp = this.rnd(2, timed ? 8 : 288) * 900000;
        const start = firstTimestamp - (firstTimestamp % 900000);
        const end = start + secondTimestamp;

        events.push({
          name: this.rndElement(this.names),
          color: '#a0a5a938',
          start,
          end,
          timed,
        });
      }
    },

    syncDateFromCalendar() {
      if (this.$refs.calendar && this.$refs.calendar.start) {
        const newDate = this.$refs.calendar.start.date;
        this.filterDate = newDate;
        this.value = newDate;
      }
    },

    onChangeDatePicker(val) {
      this.value = val;
      this.filterDate = val;
      this.menu = false;

      this.$nextTick(() => {
        if (this.$refs.calendar) {
          this.$refs.calendar.checkChange();
        }
      });
    },

    getViewIcon(viewType) {
      switch (viewType) {
        case 'month':
          return 'mdi-calendar-month';
        case 'week':
          return 'mdi-calendar-week';
        case 'day':
          return 'mdi-calendar-today';
        default:
          return 'mdi-calendar';
      }
    },

    getViewLabel(viewType) {
      switch (viewType) {
        case 'month':
          return 'Tháng';
        case 'week':
          return 'Tuần';
        case 'day':
          return 'Ngày';
        default:
          return 'Tháng';
      }
    },

    changeViewType(newType) {
      this.viewType = newType;
    },

    prev() {
      this.navigateByViewType(-1);
      // this.loadData();
    },

    next() {
      this.navigateByViewType(1);
      //  this.loadData();
    },

    navigateByViewType(direction) {
      const currentDate = moment(this.value || this.filterDate || new Date());
      let newDate;

      switch (this.viewType) {
        case 'month':
          newDate = currentDate.clone().add(direction, 'month');
          break;
        case 'week':
          newDate = currentDate.clone().add(direction, 'week');
          break;
        case 'day':
          newDate = currentDate.clone().add(direction, 'day');
          break;
        default:
          newDate = currentDate.clone().add(direction, 'month');
      }

      const newDateString = newDate.format('YYYY-MM-DD');

      this.value = newDateString;
      this.filterDate = newDateString;

      this.$nextTick(() => {
        if (this.$refs.calendar && this.$refs.calendar.checkChange) {
          this.$refs.calendar.checkChange();
        }
      });
    },

    updateValueFromCalendar() {
      this.$nextTick(() => {
        if (this.$refs.calendar) {
          const currentValue = this.$refs.calendar.parsedValue;
          if (currentValue) {
            this.value = currentValue;
            this.filterDate = currentValue;
          }
        }
      });
    },

    setToday() {
      const today = new Date().toISOString().substr(0, 10);
      this.value = today;
      this.filterDate = today;

      this.$nextTick(() => {
        if (this.$refs.calendar) {
          this.$refs.calendar.checkChange();
        }
      });
      //   this.loadData();

    },

    onCalendarChange(event) {
      if (event && event.start && event.start.date !== this.value) {
        this.value = event.start.date;
        this.filterDate = event.start.date;
      }
      if (!this.viewBool) {
        this.loadData();
      }
    },

    getCalendarTitle() {
      const currentDate = this.value ? moment(this.value) : moment();

      switch (this.viewType) {
        case 'month':
          return currentDate.locale('vi').format('MMMM/YYYY');
        case 'week': {
          const startOfWeek = currentDate.clone().startOf('week');
          const endOfWeek = currentDate.clone().endOf('week');

          return `${startOfWeek.locale('vi').format('DD MMMM')} - ${endOfWeek.locale('vi').format('DD MMMM')}`;
        }
        case 'day':
          return currentDate.locale('vi').format('dddd, DD MMMM');
        default:
          return currentDate.locale('vi').format('DD MMMM');
      }
    },

    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },

    rndElement(arr) {
      return arr[this.rnd(0, arr.length - 1)];
    },

    showEvent({ nativeEvent, event, day }) {
      if (day.past) {
        this.canRemove = false;
      } else {
        this.canRemove = true;
      }
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true)),
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },

    formatWeekday(date) {
      return date;
    },

    removeEvent() {
      this.events = this.events.filter((event) => event !== this.selectedEvent);
      this.selectedOpen = false;
    },

    async chooseCourse() {
      if (this.isAssignPermission) {
        this.$bvModal.show('coaches-calendar-modal');
      } else {
        // Non-admin: auto-select own coach, skip modal
        const user = this.currentUser;
        localStorage.setItem('coachSelectedId', user?.id);
        await this.$store.dispatch('calendarCoach/setCoachId', user?.id);
        await this.$store.dispatch('calendarCoach/setCoachName', user?.fullName);
        await this.$store.dispatch('calendarCoach/setCourse', { value: ONBOARDING.ID });
        await this.loadData();
        this.showCalendar = true;
      }
    },

    getCurrentTime() {
      return this.cal
        ? this.cal.times.now.hour * 60 + this.cal.times.now.minute
        : 0;
    },

    scrollToTime() {
      const time = this.getCurrentTime();
      const first = Math.max(0, time - (time % 30) - 30);

      this.cal.scrollToTime(first);
      const scrollTime = document.querySelector(`[data-time="${time}"]`);
      if (scrollTime) {
        const calendarContent = document.querySelector(
          '.v-calendar-daily__body',
        );
        calendarContent.scrollTop = scrollTime.offsetTop - 50;
      }
    },

    updateTime() {
      setInterval(() => this.cal.updateTimes(), 60 * 1000);
    },

    randomColors() {
      const colorCode = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += colorCode[Math.floor(Math.random() * 16)];
      }
      const invalidColors = ['#000000', '#FFFFFF', '#01645A', '#F44336'];
      if (invalidColors.includes(color)) {
        return this.randomColors();
      }
      return color;
    },

    async loadData() {
      this.coachId = this.currentUser?.id;
      this.isLoading = true;
      this.viewBool = false;
      const currentDate = this.value ? moment(this.value) : moment();

      try {
        const payload = this.removeEmpty({
          CoachId: this.coachId,
          CourseId: ONBOARDING.ID,
          Type: this.viewType,
          CurrentDate: convertToTimestamp(currentDate)
        });
        const params = new URLSearchParams();
        for (const property in payload) {
          params.append(property, payload[property]);
        }

        let endPoint = '';
        if (payload.CoachId == 'All') {
          endPoint = `CalendarCoach/CalendarAllCoach`;
        } else {
          endPoint = 'CalendarCoach/CalendarByCoach';
        }
        const { data } = await this.$api.get(endPoint, { params });

        const sevenHoursInMs = 7 * 60 * 60 * 1000;

        const coachColors = {};
        this.events =
          data?.map((el) => {
            const coachId = el.coachId;
            let color;
            if (!coachColors[coachId]) {
              coachColors[coachId] = this.randomColors();
            }
            color = coachColors[coachId];
            return {
              name: el.coachName,
              color: el.status === 0 ? el.coachColor : color,
              start: el.startTime * 1000 - sevenHoursInMs,
              end: el.endTime * 1000 - sevenHoursInMs,
              timed: true,
              status: el.status,
              courseName: el.courseName,
              courseId: el.courseId,
              calendarName: el.calendarName,
              roomId: el.roomId,
              passCode: el.passCode,
              meetingLink: el.meetingLink,
              hostEmail: el.hostEmail,
              calendarLinkDynamic: el.calendarLinkDynamic,
              calendarId: el.calendarId,
              accountId: el.accountId,
              phone: el.phoneNumber,
              type: el.type,
              goal: el.goal,
              id: el.id,
              customerName: el.customerName,
              statusMeeting: el.statusMeeting,
            };
          }) || [];

        const now = Date.now();
        this.meetingIds = this.events
          .filter(e => e.status === 1 && e.start >= now)
          .map(e => e.roomId);

        // Join broadcast groups for booked meetings
        if (this.meetingIds.length > 0 && this.$broadcast.connected) {
          for (const meetingId of this.meetingIds) {
            if (meetingId) {
              await this.$broadcast.joinMeeting(String(meetingId));
            }
          }
        }

        this.$toastr.s({
          title: 'Cập nhập thành công',
          msg: 'Lịch đã được cập nhật',
        });
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error.message || 'Failed to load calendar data',
        });
      } finally {
        this.isLoading = false;

      }
    },

    formatEventTime(start, end) {
      return `${moment(start).format(
        'HH:mm',
      )} - ${moment(end).format('HH:mm')}`;
    },

    formatEventTimeShort(start) {
      return moment(start).format('HH:mm');
    },

    // Check if event is recurring (has "[Định kỳ - Buổi X/Y]" prefix)
    isRecurringEvent(name) {
      if (!name) return false;
      return name.includes('[Định kỳ - Buổi');
    },

    // Get recurring label "[Định kỳ - Buổi X/Y]" or "Buổi X/Y"
    getRecurringLabel(name) {
      if (!name) return '';
      const match = name.match(/\[Định kỳ - Buổi (\d+\/\d+)\]/);
      return match ? `Buổi ${match[1]}` : '';
    },

    // Get display name without recurring prefix
    getEventDisplayName(name) {
      if (!name) return '';
      return name.replace(/\[Định kỳ - Buổi \d+\/\d+\]\s*/, '');
    },

    formatEventTimeSummary(start, end) {
      const startMoment = moment(start);
      const endMoment = moment(end);

      if (startMoment.isSame(endMoment, 'day')) {
        return `${startMoment.format('DD/MM/YYYY')} ${startMoment.format('HH:mm')} - ${endMoment.format('HH:mm')}`;
      } else {
        return `${startMoment.format('DD/MM/YYYY HH:mm')} - ${endMoment.format('DD/MM/YYYY HH:mm')}`;
      }
    },

    async handleSubmit() {
      this.$store.commit('context/setLoading', true);
      this.isConfirm = true;
      if (this.events.length === 0) {
        this.$toastr.e({
          title: 'Thất bại !',
          msg: 'Không được để trống lịch',
        });
        return;
      }
      const finalList = [];
      for (const event of this.events) {
        const coachId = localStorage.getItem('coachSelectedId');
        if (coachId === null) {
          this.$toastr.e({
            title: 'Lỗi !',
            msg: 'CoachId không được để trống',
          });
          return;
        }
        if (event.status !== 1) {
          finalList.push({
            CoachId: coachId,
            CourseId: this.course,
            Start: moment(event.start).format('MM/DD/YYYY HH:mm'),
            End: moment(event.end).format('MM/DD/YYYY HH:mm'),
            Status: 0,
          });
        }
      }
      const listEventsJson = JSON.stringify(finalList);

      try {
        this.isLoading = true;

        this.$store.commit('context/setLoading', true);
        if (this.coachId === 'All') {
          this.$toastr.w({
            title: 'Lưu ý!',
            msg: 'Hãy chọn một coach để đặt lịch',
          });
        }
        else
          var isUpdateSuccessful = await this.$api.post(
            'CalendarCoach/CreateMany',
            listEventsJson,
            {
              headers: { 'Content-Type': 'application/json' },
            },
          );
        if (isUpdateSuccessful) {
          this.$toastr.s({
            title: 'Thành công !',
            msg: 'Cập nhật lịch thành công',
          });
        }
        this.$store.commit('context/setLoading', false);
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message || 'Cập nhật lịch thất bại',
        });
      } finally {
        this.$emit('load-data');
        this.isLoading = false;
        this.isConfirm = false;

        this.$bvModal.hide('confirmChangeModal');
        this.$store.commit('context/setLoading', false);
      }
    },

    async viewAll() {
      try {
        this.$store.commit('context/setLoading', true);
        const { data } = await this.$api.get(
          'CalendarCoach/AllCoachBooking',
          {},
        );
        const sevenHoursInMs = 7 * 60 * 60 * 1000;

        this.events =
          data?.map((el) => {
            return {
              name: el.coachName,
              color: el.status === 0 ? el.coachColor : '#f44336',
              start: el.startTime * 1000 - sevenHoursInMs,
              end: el.endTime * 1000 - sevenHoursInMs,
              timed: true,
            };
          }) || [];
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error,
        });
      } finally {
        this.$store.commit('context/setLoading', false);
      }
    },


    formatDate(timestamp) {
      return convertTimestampToDateTime(timestamp)
    },
    formatTimeCompact(timestamp) {
      const start = moment.unix(timestamp).subtract(7, 'hours');
      const end = moment.unix(timestamp + 3600).subtract(7, 'hours');
      return `${start.format('HH:mm')} - ${end.format('HH:mm')} | ${start.format('DD/MM/YYYY')}`;
    },
    closeModalBooking() {
      this.bookedHistory = []
      this.selectedTime = null
      this.selectedType = null
      this.selectedAccount = null
      this.isDisableSelectPhone = false
      this.isChangeBooked = false
      // Reset recurrence
      this.isRecurrence = false
      this.recurrence = {
        type: { value: 'daily', text: 'Hàng ngày' },
        interval: { value: 1, text: '1' },
        endType: 'occurrences',
        endDate: '',
        occurrences: { value: 7, text: '7' },
      }
      // Reset history pagination
      this.historyPaging.page = 1
      this.historyPaging.total = 0

      this.$bvModal.hide('bookingModal')
    },
    async broadCastStatus() {
      await this.$broadcast.connect();

      this.$broadcast.on("MeetingStatusChanged", (data) => {
        const meetingId = String(data.MeetingId || data.meetingId);
        const status = data.Status ?? data.status;

        console.log("📡 Received broadcast:", { meetingId, status });

        const target = this.events.find(e => String(e.roomId) === meetingId);
        if (target) {
          target.statusMeeting = status;
          console.log(`✅ Updated meeting ${meetingId} → ${status}`);
        } else {
          console.log(`⚠️ Meeting ${meetingId} not found in list`);
        }
      });
    }

  },

  computed: {
    ...mapState(['coachId', 'course', 'coachName']),
    ...mapGetters(['currentUser']),



    filteredEvents() {
      switch (this.statusFilter) {
        case 'available':
          return this.events.filter(event => event.status === 0);
        case 'booked':
          return this.events.filter(event => event.status === 1);
        default:
          return this.events;
      }
    },

    recurrenceUnitText() {
      const units = {
        daily: 'ngày',
        weekly: 'tuần',
        monthly: 'tháng',
      };
      const typeValue = this.recurrence.type?.value || this.recurrence.type || 'daily';
      return units[typeValue] || 'ngày';
    },

    currentViewStats() {
      const allBookedEvents = this.events.filter(e => e.status === 1);
      const filteredEvents = this.filterEventsByCurrentView(allBookedEvents);

      return {
        total: filteredEvents.length,
        description: this.getCurrentViewDescription(),
        events: filteredEvents
      };
    },

    pagedBookedHistory() {
      const start = (this.historyPaging.page - 1) * this.historyPaging.pageSize;
      const end = start + this.historyPaging.pageSize;
      return this.bookedHistory.slice(start, end);
    },

    formattedEventTime() {
      if (
        this.selectedEvent &&
        this.selectedEvent.start &&
        this.selectedEvent.end
      ) {
        const startTime = moment(this.selectedEvent.start).format('HH:mm');
        const endTime = moment(this.selectedEvent.end).format('HH:mm');
        return `${startTime} - ${endTime}`;
      } else {
        return '';
      }
    },

    cal() {
      return this.ready ? this.$refs.calendar : null;
    },

    nowY() {
      return this.cal ? this.cal.timeToY(this.cal.times.now) + 'px' : '-10px';
    },

    formattedStartDate() {
      return this.course.time
        ? moment.unix(this.course.time).format('DD/MM/YYYY')
        : '';
    },

    calendarTitle() {
      return this.getCalendarTitle();
    },


    filteredCalendarType() {
      let allowed = [...this.calendarType]

      const now = Date.now()

      const countType30 = this.bookedHistory.filter(
        x => x.type === 30
      ).length

      const countType31 = this.bookedHistory.filter(
        x => x.type === 31
      ).length

      // type 30
      if (countType30 >= 2) {
        const latest30 = this.bookedHistory
          .filter(x => x.type === 30)
          .slice()
          .sort((a, b) => new Date(b.createDatetime) - new Date(a.createDatetime))[0]

        if (latest30?.createDatetime) {
          const created = new Date(latest30.createDatetime).getTime()
          const daysDiff = (now - created) / (1000 * 60 * 60 * 24)

          if (daysDiff < 21) { // chưa đủ 3 tuần
            allowed = allowed.filter(x => x.value !== '30')
          }
        } else {
          allowed = allowed.filter(x => x.value !== '30')
        }
      }

      // type 31
      if (countType31 >= 2) {
        const latest31 = this.bookedHistory
          .filter(x => x.type === 31)
          .slice()
          .sort((a, b) => new Date(b.createDatetime) - new Date(a.createDatetime))[0]

        if (latest31?.createDatetime) {
          const created = new Date(latest31.createDatetime).getTime()
          const daysDiff = (now - created) / (1000 * 60 * 60 * 24)

          if (daysDiff < 21) { // chưa đủ 3 tuần
            allowed = allowed.filter(x => x.value !== '31')
          }
        } else {
          allowed = allowed.filter(x => x.value !== '31')
        }
      }

      // type 32 (giữ logic 24h như cũ)
      const type32List = this.bookedHistory.filter(x => x.type === 32)

      if (type32List.length >= 2) {
        const latest = type32List
          .slice()
          .sort((a, b) => new Date(b.createDatetime) - new Date(a.createDatetime))[0]

        if (latest?.createDatetime) {
          const created = new Date(latest.createDatetime).getTime()
          const hoursDiff = (now - created) / (1000 * 60 * 60)

          if (hoursDiff <= 24) {
            allowed = allowed.filter(x => x.value !== '32')
          }
        }
      }

      return allowed
    }





  },

  watch: {
    viewType(newType) {
      if (newType === 'week' || newType === 'day') {
        this.$nextTick(() => {
          if (this.ready) {
            this.scrollToTime();
          }
        });
        //    this.loadData();
      }

      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },

    value(newVal) {
      if (newVal && newVal !== this.filterDate) {
        this.filterDate = newVal;
      }

      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },

    statusFilter(newFilter, oldFilter) {
      console.log(`Filter changed from ${oldFilter} to ${newFilter}`);
    },

    filterDate() {
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },

    selectedType() {
      // Chỉ reset button text khi KHÔNG phải đang đổi lịch
      if (!this.isChangeBooked) {
        this.bookingButtonText = 'Đặt lịch'
      }
    },
    'selectedAccount.accountId'(newvalue) {
      if (newvalue != null) {
        this.loadBookedMeeting();
        this.loadValidSlotByCoach("week");
      }
    }

  },

  mounted() {
    this.$refs.calendar.scrollToTime('07:00');
    this.ready = true;
    this.scrollToTime();
    this.updateTime();
    this.broadCastStatus();
  },

  created() {
    localStorage.getItem('isAdminRole');
  },

  beforeDestroy() {
    this.$broadcast.disconnect();
  },
};
</script>

<style scoped lang="scss">
.event-item-clickable {
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  padding: 8px;
  margin: 4px 0;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.1);

  &:hover {
    opacity: 0.8;
    transform: translateX(2px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: translateX(0px);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  }

  p {
    margin: 0;
    font-weight: 500;
    font-size: 12px;
  }

  .event-status {
    display: block;
    margin-top: 2px;
    opacity: 0.8;
    font-size: 10px;
  }
}

.history-table-sm {
  font-size: 12px;

  table {
    font-size: 12px;
  }

  thead th {
    font-size: 11px !important;
    padding: 0.5rem !important;
  }

  tbody td {
    font-size: 12px;
    padding: 0.4rem !important;
  }

  .dataTables_length,
  .dataTables_info {
    font-size: 11px;
  }
}

.recurring-label {
  display: inline-block;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 12px;
  margin: 5px 0;
}

.v-list-item-content {
  .v-list-item-subtitle {
    font-size: 11px;
    opacity: 0.7;
  }
}

.v-btn-toggle {
  height: 32px;

  .v-btn {
    font-size: 11px;
    min-width: 60px;

    .v-icon {
      margin-right: 4px;
    }
  }
}

.v-list-item {
  min-height: 36px;
}

.v-list-item-icon {
  margin-right: 8px;
}

.v-calendar-month-day {
  position: absolute;
  top: 4px;
  left: 4px;
  font-size: 12px;
  font-weight: 500;
}

.v-event-month {
  padding: 2px 4px;
  border-radius: 3px;
  margin-bottom: 1px;
  font-size: 10px;
  color: white;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  .event-time-month {
    font-weight: bold;
    font-size: 9px;
  }

  .event-title-month {
    font-size: 8px;
    opacity: 0.9;
    word-wrap: break-word;
    white-space: normal;
    overflow-wrap: break-word;
    line-height: 1.2;
  }

  .recurring-badge-month {
    display: inline-block;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: #fff;
    font-size: 6px;
    font-weight: 600;
    padding: 1px 4px;
    border-radius: 6px;
    margin-bottom: 1px;
    text-transform: uppercase;
    letter-spacing: 0.2px;
  }

  .event-status-month {
    font-size: 7px;
    opacity: 0.8;
  }
}

.v-card {
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
}

.v-menu {
  display: inline;
}

.v-event-draggable {
  padding-left: 6px;
}

.v-event-timed {
  user-select: none;
  -webkit-user-select: none;
}

.v-event-summary {
  color: #ffffff;
}

.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;

  &::after {
    display: none;
    position: absolute;
    left: 50%;
    height: 4px;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    width: 16px;
    margin-left: -8px;
    opacity: 0.8;
    content: '';
  }

  &:hover::after {
    display: block;
  }
}

.v-current-time {
  height: 2px;
  background-color: #ea4335;
  position: absolute;
  left: -1px;
  right: 0;
  pointer-events: none;

  &.first::before {
    content: '';
    position: absolute;
    background-color: #ea4335;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-top: -5px;
    margin-left: -6.5px;
  }
}

.v-calendar .v-event-summary {
  white-space: pre-line;
}

.v-event-draggable {
  padding: 4px;
  height: 100%;

  .event-content {
    text-align: center;
    font-size: 9px;
    line-height: 1.1;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .event-time {
    //font-weight: bold;
  }

  .event-coach {
    font-weight: 500;
  }

  .event-status-badge {
    font-size: 8px;
    padding: 1px 4px;
    border-radius: 4px;
    color: #000000;
    display: inline-block;

    &.status-booked {
      background-color: #f44336;
      color: white;
    }
  }

  .event-student,
  .event-course {
    font-size: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .event-name {
    word-wrap: break-word;
    white-space: normal;
    overflow-wrap: break-word;
    line-height: 1.2;
  }

  .recurring-badge {
    display: inline-block;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: #fff;
    font-size: 7px;
    font-weight: 600;
    padding: 2px 5px;
    border-radius: 8px;
    margin-bottom: 2px;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.2);
  }
}

.v-event-timed {
  .v-event-draggable {
    color: rgb(0, 0, 0);
    text-shadow: 0 0 2px rgba(0, 0, 0, 0.4);
  }
}

.event-item {
  list-style: none;
  padding: 6px 8px;
  margin: 3px 0;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 500;
  display: block;

  p {
    margin: 0;
    line-height: 1.2;
  }

  small {
    display: block;
    margin-top: 2px;
    font-size: 9px;
    opacity: 0.9;
  }
}

@media (max-width: 768px) {
  .event-item-clickable {
    padding: 6px;
    font-size: 10px;

    p {
      font-size: 10px;
    }

    .event-status {
      font-size: 9px;
    }
  }

  .v-card {
    margin-bottom: 8px;
  }
}

.theme--dark {
  .event-item-clickable {
    border: 1px solid rgba(255, 255, 255, 0.1);

    &:hover {
      box-shadow: 0 2px 8px rgba(255, 255, 255, 0.1);
    }
  }
}

.event-loading {
  opacity: 0.6;
  pointer-events: none;
}

.no-events {
  text-align: center;
  padding: 20px;
  color: #666;
  font-style: italic;
}

.event-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* push badge to the right */
  gap: 8px;
}

.event-time {
  font-weight: 500;
}

.event-badge {
  font-size: 13px;
  font-weight: bold;
  color: #fff;
  background-color: #e53935;
  /* red background */
  padding: 2px 8px;
  border-radius: 12px;
  animation: blink 1.2s infinite;
}

/* small blinking animation */
@keyframes blink {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }
}
</style>